import environment from 'environment';
import { getSessionToken } from 'util/parseSelectors';
import request from 'util/superagent';

const { SHIPPO_BASE_URL } = environment.eCommerce;

export const getShippoInfo = async (carrier, tracking_number) => {
  const sessionToken = getSessionToken();

  return request
    .post(`${SHIPPO_BASE_URL}/getShippingStatus`)
    .set('Accept', 'application/json')
    .set('x-session-token', sessionToken)
    .send({ carrier, tracking_number })
    .then((response) => {
      return response.body;
    });
};
